import { useNavigate, useParams, useSearchParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import ExpensableDetail from 'modules/expenses/components/expenses/Detail'
import { useExpenses } from 'modules/expenses/pages/ExpensesContext'
import { EXPENSES_SYNC_CONFIGURATION } from 'modules/expenses/pages/SyncConfiguration'
import { IntegrationsSyncContextProvider } from 'modules/integrations/public'

const GroupExpenseDetailPage = () => {
  const navigate = useNavigate()
  const { expense_id, groupId } = useParams()
  const { navigation } = useNavigation()
  const [searchParams] = useSearchParams()
  const { featureAvailabilities, data } = useExpenses()

  if (!expense_id || !groupId) {
    throw new Error('Required expense_id and groupId param')
  }

  const currencies = data?.apiCore?.currencies ?? []

  return (
    <IntegrationsSyncContextProvider configuration={EXPENSES_SYNC_CONFIGURATION}>
      <ExpensableDetail
        expensableId={expense_id}
        onClose={() =>
          navigate({
            pathname: navigation.expenses.groups.id.fullPath({ groupId }),
            search: searchParams.toString(),
          })
        }
        taxAgencyHomologationEnabled={featureAvailabilities.taxAgencyHomologation}
        reimburseThroughPayrollEnabled={featureAvailabilities.reimburseThroughPayroll}
        reimburseThroughSepaEnabled={featureAvailabilities.reimburseThroughSepa}
        reportOnBehalfEnabled={featureAvailabilities.reportOnBehalf}
        canUseSpendingPolicies={featureAvailabilities.canUseSpendingPolicies}
        canCreateExpensesForOthers={data.expenses._policies.expenseCreateExpensesForOthers.can}
        canOverrideApprovalFlow={data.expenses._policies.expenseOverrideApprovalFlow.can}
        canSetExpensableToPaid={data.expenses._policies.expenseSetToPaid.can}
        canRestartApprovalFlow={data.expenses._policies.expenseRestartApprovalFlow.can}
        canSeeEmployeeLegalEntity={data.expenses._policies.expenseSeeEmployeeLegalEntity.can}
        canReviewExpensable
        canCustomizeSettings={data.expenses._policies.expenseCustomizeSettings.can}
        projectsManagementEnabled={featureAvailabilities.projectsManagement}
        currencies={currencies}
        accountingTabEnabled
        showRecommendationSystem
        payrollData={data.payroll}
      />
    </IntegrationsSyncContextProvider>
  )
}

export default GroupExpenseDetailPage
